/**
 * Meta Pixel イベント送信ユーティリティ
 */

declare global {
  interface Window {
    fbq?: (
      action: 'track' | 'trackCustom' | 'init',
      eventName: string,
      params?: Record<string, any>
    ) => void;
  }
}

/**
 * Meta PageView イベントを送信（常に送信）
 * @param utmParams UTMパラメータ（オプション）
 */
export const trackMetaPageView = (
  utmParams?: {
    source?: string | null;
    medium?: string | null;
    campaign?: string | null;
    content?: string | null;
  }
): void => {
  if (typeof window === 'undefined' || !window.fbq) return;

  try {
    window.fbq('track', 'PageView', {
      utm_source: utmParams?.source || '',
      utm_medium: utmParams?.medium || '',
      utm_campaign: utmParams?.campaign || '',
      utm_content: utmParams?.content || '',
    });
  } catch (error) {
    if (process.env.NODE_ENV === 'development') {
      console.error('Failed to send Meta PageView event:', error);
    }
  }
};

/**
 * Metaカスタムイベント CTA_Click を送信
 * @param ctaPosition CTAの位置（'hero' | 'floating' | 'final'）
 * @param trafficType トラフィックタイプ（'ad' | 'organic'）
 */
export const trackMetaCTAClick = (
  ctaPosition: 'hero' | 'floating' | 'final',
  trafficType: 'ad' | 'organic'
): void => {
  if (typeof window === 'undefined' || !window.fbq) return;

  try {
    window.fbq('trackCustom', 'CTA_Click', {
      cta_position: ctaPosition,
      traffic_type: trafficType,
      content_name: `CTA_${ctaPosition}`, // Meta Ads Managerで識別しやすくするため
      content_category: 'CTA',
    });
  } catch (error) {
    if (process.env.NODE_ENV === 'development') {
      console.error('Failed to send Meta CTA_Click event:', error);
    }
  }
};

